import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import heroBg from '../../images/hero-background.jpg';
import './Hero.css';

export const Hero = () => {
    const { t } = useTranslation();
    const boxRef = useRef(null);

    useEffect(() => {
        const el = boxRef.current;
        if (!el) return;
        el.classList.add('bx-packed');
        const id = setInterval(() => el.classList.toggle('bx-packed'), 7000);
        return () => clearInterval(id);
    }, []);

    const scrollToSection = (id) => {
        document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
        window.history.pushState({ section: id }, '', `/${id}`);
    };

    return (
        <section id="hero" className="hero" style={{ backgroundImage: `url(${heroBg})` }}>
            <div className="hero-overlay" />
            <div className="hero-content">
                <span className="hero-badge">{t("heroBadge")}</span>
                <h1 className="hero-title">{t("heroTitle")}</h1>
                <p className="hero-subtitle">{t("heroSubtitle")}</p>
                <div className="hero-buttons">
                    <button
                        className="btn-primary-custom"
                        onClick={() => scrollToSection('transport')}
                    >
                        {t("heroLearnMore")}
                    </button>
                    <button
                        className="btn-outline-custom"
                        onClick={() => scrollToSection('contact')}
                    >
                        {t("heroContact")}
                    </button>
                </div>
            </div>
            <div className="hero-scroll-indicator">
                <div className="bx-wrap">
                    <div className="bx-scene" ref={boxRef}>
                        <div className="bx-pw">
                            <div className="bx-p">
                                <div className="bx-s bx-s-main">
                                    <div className="bx-f bx-f-top" />
                                    <div className="bx-f bx-f-bot" />
                                    <div className="bx-s bx-s-tabbed">
                                        <div className="bx-f bx-f-top" />
                                        <div className="bx-f bx-f-bot" />
                                    </div>
                                    <div className="bx-s bx-s-extra">
                                        <div className="bx-f bx-f-top" />
                                        <div className="bx-f bx-f-bot" />
                                        <div className="bx-s bx-s-flipped">
                                            <div className="bx-f bx-f-top" />
                                            <div className="bx-f bx-f-bot" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};
